import type from './type';

const INITIAL_STATE = {
  loading: false,
  list: [],
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case type.QUIZZES_LOAD:
      return { ...state, loading: action.payload };
    case type.QUIZZES_FETCHED:
      return { ...state, list: action.payload, loading: false };
    case type.QUIZ_CHOSEN:
      return { ...state, quiz: action.payload };
    default:
      return state;
  }
};
